const talk = [

    {
        name: '02zhawuyuan_deuihua',
        width: 796,
        height: 116,
        top: 262,
        left: 11511 ,
        opc: 0,
    },
// + 850
    {
        name: 'cheliangjianxiugong_duihua',
        width:  493,
        height: 116,
        top:433,
        left:17605 ,
        opc:0,
    },

    // {
    //     name: 'cheliangjianxiugong_duihua',
    //     width:  644,
    //     height: 116,
    //     top: 271,
    //     left: 13871 ,
    //     opc: 0,
    // },
//  + 820
]

export default talk;